import React from 'react';
import cx from 'classnames';
import css from './css';

interface Props {
  htmlFor?: string;
  style?: object;
  className?: string;
  tooltip?: string | React.ReactNode;
  children?: React.ReactNode;
  inline?: boolean;
}

export default function Label(props: Props) {
  const {
    tooltip, className, inline, ...rest
  } = props;

  return (
    <label
      // @ts-ignore
      className={cx(styles.label, className, !inline && styles.fixed)}
      data-tip={tooltip}
      {...rest}
    >
      {props.children}
    </label>
  );
}

const styles = css({
  label: {
    fontFamily: '"Lato", sans-serif',
    display: 'block',
    margin: 0,
    lineHeight: '1.8',
    color: '#777',
    fontSize: 13,
  },

  fixed: {
    minWidth: '6em',
  },
});
